//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.ShipDesign.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Features.js";
let d=[[[0,"BulkheadEnum",1,0],[0,"DeckEnum",1,0],[0,"InterSectionsType",1,0],[0,"InterTransFrameEnum",1,0],[0,"ReadDataSet",0,"Features.ShipDesign.ReadDataSetBuilder",0],[0,"TransFrameEnum",1,0],[0,"YFrameEnum",1,0],[0,"ZFrameEnum",1,0]],[],[]];
SPLM.Features.ShipDesign.ShipIntersectionsBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ShipDesign.ShipIntersectionsBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.ShipDesign.ShipIntersectionsBuilder.CreationType = Object.freeze({
    "Manual" : "Manual", "Spreadsheet" : "Spreadsheet"});

SPLM.Features.ShipDesign.ShipIntersectionsBuilder.Type = Object.freeze({
    "None" : "None", "SheetBodies" : "SheetBodies", "Curves" : "Curves", "All" : "All"});

export default SPLM;